import { render } from "./TermsAndPrivacyKycReuse.vue.ts?vue&type=template&id=26f2ea1f&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyKycReuse.vue?vue&type=template&id=26f2ea1f&scoped=true&ts=true"
import script from "./TermsAndPrivacyKycReuse.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyKycReuse.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsAndPrivacyKycReuse.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyKycReuse.vue?vue&type=script&setup=true&lang=ts"

import "./TermsAndPrivacyKycReuse.vue.scss?vue&type=style&index=0&id=26f2ea1f&lang=scss&scoped=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyKycReuse.vue?vue&type=style&index=0&id=26f2ea1f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f2ea1f"],['__file',"src/apps/merchant3/components/customer-registration/terms-and-privacy/TermsAndPrivacyKycReuse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26f2ea1f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26f2ea1f', __exports__)) {
    api.reload('26f2ea1f', __exports__)
  }
  
  module.hot.accept("./TermsAndPrivacyKycReuse.vue.ts?vue&type=template&id=26f2ea1f&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyKycReuse.vue?vue&type=template&id=26f2ea1f&scoped=true&ts=true", () => {
    api.rerender('26f2ea1f', render)
  })

}


export default __exports__